<template>

    <div class="scene" @mouseover="mouseOverEvent" @mouseleave="mouseLeaveEvent">

        <v-fade-transition hide-on-leave>
            <v-icon class="info-icon" small v-show="(infoIconVisible && flippable) || showInfoIcon">mdi-information-outline</v-icon>
        </v-fade-transition>

        <div :class="mouseOver && flippable ? 'card is-flipped' : 'card'">

            <!-- FRONT SIZE -->
            <v-card class="d-flex flex-column card__face card__face--front align-content-space-between"
                    raised
                    :color="color"
                    :height="height"
            >
                <div v-if="hintAtTop" class="ml-3 hint-top d-flex justify-space-between">
                    <div class="white--text body-2 align-self-end">
                        <span>{{ hint }}</span>
                    </div>
                </div>

                <animated-value
                    class="ml-3 mt-auto mb-auto"
                    :value="value"
                    :prefix="prefix"
                    :prefix-icon="prefixIcon"
                    :postfix="postfix"
                    :postfix-icon="postfixIcon"
                    :key="key"
                    :animate="animate"
                ></animated-value>

                <div v-if="!hintAtTop" class="ml-3 hint-bottom d-flex justify-space-between">
                    <div class="white--text body-2 align-self-top">
                        <span>{{ hint }}</span>
                    </div>
                </div>
            </v-card>

            <!-- BACK SIDE -->
            <v-card class="d-flex flex-column card__face card__face--back align-content-space-between"
                    raised
                    :color="mouseOverColor ? mouseOverColor : color"
                    :height="height"
            >

                <div v-if="hintAtTop" class="ml-3 hint-top d-flex justify-space-between">
                    <div class="white--text body-2 align-self-end">
                        <span>{{ mouseOverHint }}</span>
                    </div>
                </div>

                <animated-value
                    class="ml-3 mt-auto mb-auto"
                    :value="mouseOverValue"
                    :prefix="mouseOverPrefix"
                    :prefix-icon="mouseOverPrefixIcon"
                    :postfix="mouseOverPostfix"
                    :postfix-icon="mouseOverPostfixIcon"
                    :key="keyMouseOver"
                    :animate="animate"
                ></animated-value>

                <div v-if="!hintAtTop" class="ml-3 hint-bottom d-flex justify-space-between">
                    <div class="white--text body-2 align-self-top">
                        <span>{{ mouseOverHint }}</span>
                    </div>
                </div>

            </v-card>
        </div>

    </div>

</template>

<script>

import AnimatedValue from './AnimatedValue';
import {v4 as uuid} from 'uuid';

export default {

    components: {
        AnimatedValue,
    },

    props: {
        'value': {
            type: Number,
            required: true,
            default: null
        },
        'prefix': {
            type: String,
            required: false,
            default: ''
        },
        'prefixIcon': {
            type: String,
            required: false,
            default: null,
        },
        'postfix': {
            type: String,
            required: false,
            default: ''
        },
        'postfixIcon': {
            type: String,
            required: false,
            default: ''
        },
        'hint': {
            type: String,
            required: true,
        },

        'mouseOverValue': {
            type: Number | null,
            required: false,
            default: null
        },
        'mouseOverPrefix': {
            type: String,
            required: false,
            default: ''
        },
        'mouseOverPrefixIcon': {
            type: String,
            required: false,
            default: null,
        },
        'mouseOverPostfix': {
            type: String,
            required: false,
            default: ''
        },
        'mouseOverPostfixIcon': {
            type: String,
            required: false,
            default: ''
        },
        'mouseOverHint': {
            type: String,
            required: false
        },
        'mouseOverColor': {
            type: String,
            required: false,
        },
        'height': {
            type: Number,
            required: false,
            default: 100
        },
        'color': {
            type: String,
            required: false,
            default: 'primary'
        },
        'animate': {
            type: Boolean,
            required: false,
            default: true
        },
        'loading': {
            type: Boolean,
            required: false,
            default: false
        },
        'hintAtTop': {
            type: Boolean,
            required: false,
            default: false
        },
        'elevation': {
            type: Number,
            required: false,
            default: 2
        },
        'showInfoIcon': {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            mouseOver: false,
            key: null,
            keyMouseOver: null,
            infoIconVisible: true
        }
    },

    mounted() {
        this.key = uuid();
        this.keyMouseOver = uuid();
    },

    methods: {
        mouseOverEvent() {
            this.mouseOver = true;
            this.infoIconVisible = false;
        },
        mouseLeaveEvent() {
            this.mouseOver = false;

            setTimeout(() => {
                this.infoIconVisible = true;
            }, 400);
        }
    },

    computed: {

        contentHeight() {
            return this.height - 52;
        },

        showPrimary() {
            return this.mouseOver === false || this.mouseOverValue === null
        },

        flippable() {
            return this.mouseOverValue !== null;
        }
    },
}
</script>

<style scoped>

.scene {
    height: 100px;
    perspective: 600px;
}

.info-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 100;
}

/* The flip card container - set the width and height to whatever you want. We have added the border property to
demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
.card {
    width: 100%;
    height: 100px;
    transition: transform 0.5s;
    transform-style: preserve-3d;
}

.card.is-flipped {
    transform: rotateY(180deg);
}

.hint-top {
    height: 32px;
}

.hint-bottom {
    height: 32px;
}

.card__face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
}

.card__face--front {
}

.card__face--back {
    transform: rotateY(180deg);
}


</style>
